function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';

import { useLoaderData } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { intersectionBy, keyBy, merge, values } from 'lodash';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate, I18NApi, t } from "../../../../I18N";
import { RequestParams } from "../../../../utils/RequestParams";
import { settingsAtom } from "../../../atoms/settingsAtom";
import { Button, Table, ConfirmationModal } from "../../../Components/UI";
import { useApiCaller } from "../../../CustomHooks/useApiCaller";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";

import { InstallLanguagesModal } from "./components/InstallLanguagesModal";
import {
  DefaultHeader,
  LabelHeader,
  ResetHeader,
  UninstallHeader,
  DefaultButton,
  ResetButton,
  UninstallButton,
  LanguageLabel } from "./components/TableComponents";


const languagesListLoader =
(headers) =>
async () =>
I18NApi.getLanguages(new RequestParams({}, headers));
// eslint-disable-next-line max-statements
const LanguagesList = () => {
  const { languages: collectionLanguages = [] } = useAtomValue(settingsAtom);
  const { requestAction } = useApiCaller();
  const [modalProps, setModalProps] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showInstallModal, setShowInstallModal] = useState(false);

  const availableLanguages = useLoaderData();
  const installedLanguages = intersectionBy(availableLanguages, collectionLanguages, 'key');
  const notInstalledLanguages = availableLanguages.filter(
    (l) => !collectionLanguages.find((cl) => cl.key === l.key)
  );
  const languages = values(
    merge(keyBy(installedLanguages, 'key'), keyBy(collectionLanguages, 'key'))
  );

  const handleAction =
  (
  successMessage,
  action,
  key,
  currentLanguage) =>

  async () => {
    setShowModal(false);
    if (currentLanguage) {
      await requestAction(
        action,
        new RequestParams({ [key]: currentLanguage.key }),
        successMessage
      );
    }
  };

  const confirmAction = (
  message,
  acceptLabel,
  handleAcceptedAction) =>
  {
    setModalProps({
      header: t('System', 'Are you sure?', null, false),
      body: message,
      acceptButton: acceptLabel,
      cancelButton: t('System', 'No, cancel', null, false),
      warningText: t('System', 'Other users will be affected by this action!', null, false),
      confirmWord: t('System', 'CONFIRM', null, false),
      onAcceptClick: handleAcceptedAction,
      onCancelClick: () => setShowModal(false),
      size: 'md'
    });
    setShowModal(true);
  };

  const resetModal = (row) => {
    confirmAction(
      'You are about to reset a language.',
      'Reset',
      handleAction( /*#__PURE__*/
        _jsx(Translate, {}, void 0, "Language reset success"),
        I18NApi.populateTranslations,
        'locale',
        row.original
      )
    );
  };

  const setDefaultLanguage = async (row) => {
    await handleAction( /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Default language change success"),
      I18NApi.setDefaultLanguage,
      'key',
      row.original
    )();
  };

  const uninstallModal = (row) => {
    confirmAction(
      'You are about to uninstall a language.',
      'Uninstall',
      handleAction( /*#__PURE__*/
        _jsx(Translate, { translationKey: "Language Uninstall Start Message" }, void 0, "Language uninstallation process initiated. It may take several minutes to complete depending on the size of the collection. Please wait until the uninstallation process is finished."



        ),
        I18NApi.deleteLanguage,
        'key',
        row.original
      )
    );
  };

  // Helper typed as any because of https://github.com/TanStack/table/issues/4224
  const columnHelper = createColumnHelper();
  const columns = [
  columnHelper.accessor('label', {
    id: 'label',
    header: LabelHeader,
    cell: LanguageLabel,
    meta: { headerClassName: 'w-9/12' }
  }),
  columnHelper.accessor('default', {
    header: DefaultHeader,
    cell: DefaultButton,
    enableSorting: false,
    meta: { action: setDefaultLanguage, headerClassName: 'text-center w-1/12' }
  }),
  columnHelper.accessor('key', {
    header: ResetHeader,
    cell: ResetButton,
    enableSorting: false,
    meta: { action: resetModal, headerClassName: 'text-center w-1/12' }
  }),
  columnHelper.accessor('_id', {
    header: UninstallHeader,
    cell: UninstallButton,
    enableSorting: false,
    meta: { action: uninstallModal, headerClassName: 'text-center w-1/12' }
  })];


  return /*#__PURE__*/(
    _jsx("div", {
      className: "tw-content",
      style: { width: '100%', overflowY: 'auto' },
      "data-testid": "settings-languages" }, void 0, /*#__PURE__*/

    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Languages" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx("div", { "data-testid": "languages" }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: columns,
      data: languages,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Active languages"),
      initialState: { sorting: [{ id: 'label', desc: false }] } }
    )
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      onClick: () => {
        setShowInstallModal(true);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Install Language(s)")
    )
    )
    )
    ),
    showModal && /*#__PURE__*/
    _jsx("div", { className: "container w-10 h-10" }, void 0, /*#__PURE__*/
    React.createElement(ConfirmationModal, _extends({}, modalProps, { size: "md" }))
    ),

    showInstallModal && /*#__PURE__*/
    _jsx(InstallLanguagesModal, {
      setShowModal: setShowInstallModal,
      languages: notInstalledLanguages }
    )

    ));

};

export { LanguagesList, languagesListLoader };